import { useContext, useEffect, useState } from "react";
import { BsFillHeartPulseFill } from "react-icons/bs";
import { FaBed } from "react-icons/fa";
import { MdSignalWifiConnectedNoInternet2 } from "react-icons/md";
import { IoIosWifi } from "react-icons/io";
import { TfiHeartBroken } from "react-icons/tfi";
import "./style.css";
import { Link } from "react-router-dom";
import slugify from "react-slugify";
import { DasboardContext } from "../../context/dashboard-context";
import AlarmModal from "../AlarmModal/AlarmModal";
import LastFiveAlarm from "../LastFiveAlarm/LastFiveAlarm";
import Form from "react-bootstrap/Form";
import Accordion from "react-bootstrap/Accordion";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { SlSpeedometer } from "react-icons/sl";
import { FaPlugCircleXmark } from "react-icons/fa6";
import { PiBedFill } from "react-icons/pi";
import { FaRegCalendarCheck } from "react-icons/fa";
import { GiRadarSweep } from "react-icons/gi";
import { FaHeartbeat, FaLungs, FaIdBadge } from "react-icons/fa";
import { BiSolidWatchAlt } from "react-icons/bi";
import { ImHeart } from "react-icons/im";
import { FaLocationDot, FaBatteryThreeQuarters } from "react-icons/fa6";
import { IoManSharp } from "react-icons/io5";
import { MdLocationPin } from "react-icons/md";

import { FcInfo } from "react-icons/fc";

const SameSuitCard = ({ bed }) => {
  const [show, setShow] = useState(false);
  const [lastAlarmsShow, setLastAlarmsShow] = useState(false);
  const [minidata, setMinidata] = useState([]);
  const [suBed, setSuBed] = useState();
  const [alarms, setAlarms] = useState([]);
  const [userDetail, setUserDetail] = useState([]);
  const [alarm, setAlarm] = useState();
  const [lastAlarmId, setLastAlarmId] = useState();

  const [heartBreath, setHeartBreath] = useState([]);
  const [position, setPosition] = useState([]);
  const [hbstatics, setHbstatics] = useState([]);

  const [outBedModalShow, setOutBedModalShow] = useState(true);

  const outBedClose = () => setOutBedModalShow(false);
  const outBedShow = () => setOutBedModalShow(true);

  const {
    states,
    events,
    topic,
    setCheckedItems,
    filter,
    messages,
    battery,
    hobaData,
  } = useContext(DasboardContext);

  const [bedStatesMap, setBedStatesMap] = useState({});
  const [bedEventsMap, setBedEventsMap] = useState({});
  const [hobaEventsMap, setHobaEventsMap] = useState({});
  const [bedMessagesMap, setBedMessagesMap] = useState({});

  const [logs, setLogs] = useState({});

  const handleShow = () => setShow(true);
  const closeModal = () => setShow(false);
  const closeLastAlarmsModal = () => setLastAlarmsShow(false);

  const handleToggleChange = (deviceID, isChecked) => {
    if (isChecked) {
      setCheckedItems((prevItems) => [...prevItems, deviceID]);
    } else {
      setCheckedItems((prevItems) => prevItems.filter((id) => id !== deviceID));
    }
  };

  const symbols = {
    Mutfak: "countertops",
    Banyo: "bathtub",
    "Yatak Odası": "king_bed",
    "Yemek Odası": "table_restaurant",
    "Oturma Odası": "scene",
  };

  function extractIdFromUrl() {
    const parts = topic?.split("/");
    const idPart = parts?.find((part) => part.startsWith("id_"));
    return idPart || null;
  }

  async function getAlarmDetail() {
    try {
      const promises = bed.items.map(async (sbed) => {
        const response = await fetch(
          `https://app.vivasmartcare.com/api/alarm-logs/${sbed.deviceID}`
        );
        return response.json();
      });

      const alarmResponses = await Promise.all(promises);
      setAlarms((prevAlarms) => [...prevAlarms, ...alarmResponses]);
    } catch (error) {
      console.error("Veri getirilirken bir hata oluştu:", error);
    }
  }

  async function getUserDetails() {
    try {
      const promises = bed?.items.map(async (sbed) => {
        const response = await fetch(
          `https://app.vivasmartcare.com/api/user/${sbed.person}`
        );
        return response.json();
      });
      const userDetails = await Promise.all(promises);
      setUserDetail((prevUser) => [...prevUser, ...userDetails]);
    } catch (error) {
      console.error("Veri getirilirken bir hata oluştu:", error);
    }
  }

  function countAlarmsByDeviceId(alarms, deviceID) {
    let count = 0;

    alarms
      .filter((alarmArray) => alarmArray.length > 0)
      .forEach((alarmArray) => {
        const filteredAlarms = alarmArray.filter(
          (alarm) => alarm.deviceId === deviceID
        );
        count += filteredAlarms.length;
      });

    return count;
  }

  function dateFormat(myDate) {
    const options = {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: false,
      timeZone: "Europe/Istanbul",
    };
    return new Date(myDate).toLocaleDateString("tr-TR", options);
  }

  useEffect(() => {
    setSuBed(bed);
    getAlarmDetail();
    getUserDetails();
    console.log(battery);
  }, [bed]);

  useEffect(() => {
    const updateMaps = () => {
      const newBedStatesMap = { ...bedStatesMap };

      bed.items.forEach((sbed) => {
        if (states.deviceId === sbed.deviceID) {
          newBedStatesMap[sbed.deviceID] = { ...states };
        }
      });

      setBedStatesMap(newBedStatesMap);
    };

    updateMaps();
  }, [states]);

  useEffect(() => {
    const updateMaps = () => {
      const newBedEventsMap = { ...bedEventsMap };

      bed.items.forEach((sbed) => {
        if (extractIdFromUrl(topic) === sbed.deviceID) {
          newBedEventsMap[sbed.deviceID] = { ...events };
        }
      });

      setBedEventsMap(newBedEventsMap);
    };

    updateMaps();
  }, [events]);

  const eventTypeMap = {
    calling: "Düşme Alarmı",
    inBed: "Yatağa Girme",
    "In Bed": "Yatağa Girme",
    outOfBed: "Yataktan Çıkma",
    "Out Of Bed": "Yataktan Çıkma",
    awayFromBed: "Yataktan Uzakta",
    bp: "Tansiyon Alarmı",
    rr: "Solunum Sayısı",
    hr: "Kalp Atış Hızı",
    bt: "Vücut Sıcaklığı Alarmı",
    callButton: "Aranma",
    fall: "Düşme Önleme Alarmı",
    falldetected: "Düşme Alarmı",
    "Low Heart Rate": "Düşük Kalp Atış Hızı",
    "High Heart Rate": "Yüksek Kalp Atış Hızı",
    "Low Respiration Rate": "Düşük Solunum Hızı",
    "High Respiration Rate": "Yüksek Solunum Hızı",
    head: "Epilepsi Alarmı",
    spo: "Oksijen Saturasyonu",
    tback: "Bası Yarası Hatırlatma",
    tleft: "Bası Yarası Hatırlatma",
    tright: "Bası Yarası Hatırlatma",
    "Posture Change": "Bası Yarası Hatırlatma",
    "Leave area": "Yataktan Çıkma",
    "Enter area": "Yatağa Girme",
    "Enter room": "Odaya Girme",
    "Leave room": "Odadan Çıkma",
    "Turn Resident": "Bası Yarası Hatırlatma",
  };

  return (
    <>
      <div className="bed-card">
        {bed?.items[0].organization && (
          <Link
            className="organisation-name"
            to={`/nursing-home-detail/${slugify(bed?.items[0].organization)}`}
          >
            {bed?.items[0].organization}
          </Link>
        )}

        {bed?.suiteName && bed?.suiteName !== "" && (
          <div className="room-name suite">{bed?.suiteName}</div>
        )}

        {bed?.items?.map((bedItem) => (
          <div key={bedItem?.deviceID} className="same-card">
            <div className="room-name">
              {bedItem?.brand === "Viva02P" ? (
                <div className="vital-box">
                  <a href={`/viva02p/${bedItem?.deviceID}`}>
                    <TfiHeartBroken size={16} color="red" /> {bedItem?.roomName}
                  </a>
                  <a href={`/viva02p/activities/${bedItem?.deviceID}`}>
                    <FaRegCalendarCheck color="black" />
                  </a>
                </div>
              ) : bedItem?.brand === "Viva03D" ? (
                <div className="hobacare-box">
                  <a href={`/viva02p/${bedItem?.deviceID}`}>
                    <GiRadarSweep color="red" />
                  </a>
                  {bedItem?.roomName}
                </div>
              ) : bedItem?.brand === "Vivistar" ? (
                <div className="hobacare-box">
                  <BiSolidWatchAlt color="red" size={16} />
                  {bedItem?.roomName}
                </div>
              ) : (
                <>{bedItem?.roomName}</>
              )}
            </div>

            {bedItem?.brand !== "Viva02P" &&
              bedItem?.brand !== "Viva03D" &&
              bedItem?.brand !== "Vivistar" && (
                <Form.Group
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    label="Bildirimler Kapalı"
                    onChange={(e) =>
                      handleToggleChange(bedItem?.deviceID, e.target.checked)
                    }
                  />
                </Form.Group>
              )}

            {/* Hobacare verileri buraya gelecek */}
            {bedItem?.brand === "Viva03D" &&
              hobaData[bedItem?.deviceID] && (
                <div>
                  <p>
                    {(() => {
                      const deviceData = hobaData[bedItem?.deviceID];
                      const base64 = deviceData?.payload?.heartbreath;
                      if (!base64)
                        return (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <p>-- --</p>
                            <a
                              href={`https://qinglanst.com/single/rommDetails?uid=${bedItem?.deviceID}&token=c60da4de-3b6e-4154-90e0-ef021c462c2a&readOnly=true&isApp=true`}
                              target="_blank"
                            >
                              <MdLocationPin size={24} />
                            </a>
                          </div>
                        );

                      let heartData;
                      try {
                        const binaryString = atob(base64);
                        const bytes = Uint8Array.from(binaryString, (c) =>
                          c.charCodeAt(0)
                        );

                        const statusByte = bytes[13] || 0;
                        const sleepBits = (statusByte >> 6) & 0b11;

                        // Posture (yatakta olup olmama kontrolü)
                        const postureValue = statusByte;
                        const inBedStates = [6, 9, 10, 11];
                        const isInBed = inBedStates.includes(postureValue);

                        const sleepStateMap = {
                          0b00: "Tanımsız",
                          0b01: "Hafif uyku",
                          0b10: "Derin uyku",
                          0b11: "Uyanık",
                        };

                        heartData = {
                          identifier: bytes[0],
                          breathing: bytes[1],
                          heartRate: bytes[2],
                          sleepState: sleepStateMap[sleepBits] || "Bilinmiyor",
                          inBed: isInBed,
                        };
                      } catch (e) {
                        return "Geçersiz Base64";
                      }

                      return (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "12px",
                          }}
                        >
                          <div className="hobadata">
                            <p>Solunum</p>
                            <p>{heartData.breathing} rpm</p>
                          </div>
                          <div className="hobadata">
                            <p>Nabız</p>
                            <p>{heartData.heartRate} bpm</p>
                          </div>
                        </div>
                      );
                    })()}
                  </p>

                  {/* <p>position {hobaData?.payload?.position}</p>
                  <p>statics {hobaData?.payload?.hbstatics}</p> */}
                </div>
              )}

            {/* Vivistart */}
            {bedItem?.brand === "Vivistar" && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                }}
              >
                <div className="hobadata">
                  <FaLungs />
                  <p>SpO2: --</p>
                </div>
                <div className="hobadata">
                  <FaHeartbeat />
                  <p>Kalp Atışı: --</p>
                </div>
                <div className="hobadata">
                  <ImHeart />
                  <p>Tansyion: --</p>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "8px",
                    cursor: "pointer",
                  }}
                >
                  <FaLocationDot />
                  <p style={{ fontSize: "13px" }}>Canlı Konum</p>
                </div>
              </div>
            )}

            {["Viva02P"].includes(bedItem?.brand) && (
              <div className="vitals-wrapper">
                <div className="vitals-container">
                  <div className="title">Nabız</div>
                  <div className="box">
                    <div className="left-box">
                      <p>
                        {(() => {
                          const matchingMessages = messages.filter(
                            (message) => message.deviceId === bedItem.deviceID
                          );

                          const highestHRMessage = matchingMessages.reduce(
                            (max, current) =>
                              current.HR > (max.HR || 0) ? current : max,
                            {}
                          );
                          return highestHRMessage?.HR ? (
                            highestHRMessage.HR
                          ) : (
                            <p>--</p>
                          );
                        })()}
                      </p>
                      <p>
                        {(() => {
                          const matchingMessages = messages.filter(
                            (message) => message.deviceId === bedItem.deviceID
                          );
                          const lowestHRMessage = matchingMessages.reduce(
                            (min, current) =>
                              current.HR < (min.HR || Infinity) ? current : min,
                            {}
                          );
                          return lowestHRMessage?.HR ? (
                            lowestHRMessage.HR
                          ) : (
                            <p>--</p>
                          );
                        })()}
                      </p>
                    </div>
                    <div className="right-box">
                      <p>
                        {(() => {
                          const matchingMessages = messages.filter(
                            (message) => message.deviceId === bedItem.deviceID
                          );
                          const lastMessage =
                            matchingMessages[matchingMessages.length - 1];
                          return lastMessage?.HR ? lastMessage.HR : <p>--</p>;
                        })()}
                      </p>
                    </div>
                  </div>
                  <p className="bpm">bpm</p>
                </div>
                <div className="vitals-container">
                  <div className="title">Solunum</div>
                  <div className="box">
                    <div className="left-box">
                      <p>
                        {(() => {
                          const matchingMessages = messages.filter(
                            (message) => message.deviceId === bedItem.deviceID
                          );

                          const highestRRMessage = matchingMessages.reduce(
                            (max, current) =>
                              current.RR > (max.RR || 0) ? current : max,
                            {}
                          );
                          return highestRRMessage?.RR ? (
                            highestRRMessage.RR
                          ) : (
                            <p>--</p>
                          );
                        })()}
                      </p>
                      <p>
                        {(() => {
                          const matchingMessages = messages.filter(
                            (message) => message.deviceId === bedItem.deviceID
                          );
                          const lowestRRMessage = matchingMessages.reduce(
                            (min, current) =>
                              current.RR < (min.RR || Infinity) ? current : min,
                            {}
                          );
                          return lowestRRMessage?.RR ? (
                            lowestRRMessage.RR
                          ) : (
                            <p>--</p>
                          );
                        })()}
                      </p>
                    </div>
                    <div className="right-box">
                      <p>
                        {(() => {
                          const matchingMessages = messages.filter(
                            (message) => message.deviceId === bedItem.deviceID
                          );
                          const lastMessage =
                            matchingMessages[matchingMessages.length - 1];
                          return lastMessage?.RR ? lastMessage.RR : <p>--</p>;
                        })()}
                      </p>
                    </div>
                  </div>
                  <p className="bpm">rpm</p>
                </div>
                <div className="moving">
                  <p className="title">Hareketlilik</p>
                  <SlSpeedometer />
                </div>
              </div>
            )}

            {countAlarmsByDeviceId(alarms, bedItem.deviceID) > 3 ? (
              <Accordion>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    Alarm Sayısı{" "}
                    <span className="alarm-count">
                      {countAlarmsByDeviceId(alarms, bedItem.deviceID)}
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    {alarms
                      ?.filter((alarmArray) => alarmArray.length > 0)
                      .flat()
                      .filter((alarm) => alarm.deviceId === bedItem.deviceID)
                      .sort(
                        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
                      )
                      .map((alarm, index) => {
                        const alarmLabel =
                          eventTypeMap[alarm?.eventType] || "Alarm";
                        const alarmClass =
                          alarm?.eventType === "calling" ? "red" : "yellow";

                        return (
                          <div className="alarms" key={index}>
                            <div
                              className={`alarm-type ${alarmClass}`}
                              onClick={() => {
                                handleShow();
                                setAlarm(alarm);
                              }}
                            >
                              {alarmLabel}
                            </div>
                          </div>
                        );
                      })}
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            ) : (
              alarms
                ?.filter((alarmArray) => alarmArray.length > 0)
                .map((alarmArray, index) =>
                  alarmArray
                    .filter((alarm) => alarm.deviceId === bedItem.deviceID)
                    .map((alarm, subIndex) => (
                      <div className="alarms">
                        <div
                          key={`${index}-${subIndex}`}
                          className={`alarm-type ${
                            alarm?.eventType !== "calling" ? "yellow" : "red"
                          }`}
                          onClick={() => {
                            handleShow();
                            setAlarm(alarm);
                          }}
                        >
                          {eventTypeMap[alarm?.eventType]}
                        </div>
                      </div>
                    ))
                )
            )}
            <div
              className="device-container"
              onClick={() => {
                setLastAlarmId(bedItem?.deviceID);
                setLastAlarmsShow(true);
              }}
            >
              <div className="device-wrapper">
                {logs &&
                  logs.length > 0 &&
                  (() => {
                    const filteredLogs = logs.filter(
                      (log) =>
                        log.deviceId === bedItem?.deviceID &&
                        log.dataType === "event"
                    );
                    const lastFilteredLog =
                      filteredLogs[filteredLogs.length - 1];

                    const isPresenceDetected =
                      lastFilteredLog &&
                      lastFilteredLog.vayyarData?.payload &&
                      lastFilteredLog.vayyarData.payload.presenceDetected ===
                        true;

                    return isPresenceDetected ? (
                      <>
                        <span
                          className={`material-symbols-rounded ${
                            isPresenceDetected && "in-bed"
                          }`}
                        >
                          {symbols[bedItem?.roomType]}
                        </span>
                      </>
                    ) : (
                      <span className="material-symbols-rounded">
                        {symbols[bedItem?.roomType]}
                      </span>
                    );
                  })()}
                {bedEventsMap[bedItem?.deviceID]?.payload?.presenceDetected ===
                  false && (
                  <span className={`material-symbols-rounded`}>
                    {symbols[bedItem?.roomType]}
                  </span>
                )}
                {bedEventsMap[bedItem?.deviceID]?.payload?.presenceDetected ===
                  true && (
                  <span className={`material-symbols-rounded in-bed`}>
                    {symbols[bedItem?.roomType]}
                  </span>
                )}
                {bedEventsMap[bedItem?.deviceID]?.payload
                  ?.presenceRegionMap?.[0] === 1 &&
                  bedItem?.roomType === "Yatak Odası" && (
                    <>
                      <FaBed fill="orange" />
                    </>
                  )}
                {logs &&
                  logs.length > 0 &&
                  (() => {
                    const filteredLogs = logs.filter(
                      (log) =>
                        log.deviceId === bedItem?.deviceID &&
                        log.dataType === "event"
                    );

                    const lastFilteredLog =
                      filteredLogs[filteredLogs.length - 1];
                    const secondLastFilteredLog =
                      filteredLogs[filteredLogs.length - 2];

                    const isOutBed =
                      lastFilteredLog &&
                      secondLastFilteredLog &&
                      lastFilteredLog.vayyarData?.payload &&
                      lastFilteredLog.vayyarData?.payload.presenceRegionMap &&
                      secondLastFilteredLog.vayyarData?.payload &&
                      secondLastFilteredLog.vayyarData?.payload
                        .presenceRegionMap &&
                      lastFilteredLog.vayyarData?.payload
                        .presenceRegionMap[0] === 0 &&
                      secondLastFilteredLog.vayyarData?.payload
                        .presenceRegionMap[0] === 1;

                    return (
                      isOutBed &&
                      bedItem?.brand !== "Minifinder" &&
                      bedItem?.roomType === "Yatak Odası" && (
                        <>
                          <Modal show={outBedModalShow} onHide={outBedClose}>
                            <Modal.Header closeButton>
                              <Modal.Title>
                                {bedItem.suiteName} adlı süit için yataktan
                                çıkma bildirimi
                              </Modal.Title>
                            </Modal.Header>
                            <Modal.Body></Modal.Body>
                            <Modal.Footer>
                              <Button variant="secondary" onClick={outBedClose}>
                                Kapat
                              </Button>
                            </Modal.Footer>
                          </Modal>
                        </>
                      )
                    );
                  })()}
                {/* Wifi Status */}
                {bedStatesMap[bedItem?.deviceID]?.wifiState.rssi <= -80 && (
                  <div className="rssi">!</div>
                )}
                {/* Vayyar Online Offline */}
                {(bedItem.brand === "Viva02P" || bedItem.brand === "Vayyar") &&
                  (messages.some(
                    (message) => message.deviceId === bedItem.deviceID
                  ) ||
                  bedStatesMap[bedItem.deviceID]?.status === "test" ||
                  bedStatesMap[bedItem.deviceID]?.status === "learning" ||
                  bedStatesMap[bedItem.deviceID]?.status === "monitoring" ? (
                    <IoIosWifi fill="green" />
                  ) : (
                    <MdSignalWifiConnectedNoInternet2 fill="red" />
                  ))}

                {bedItem.brand === "Viva03D" &&
                  (() => {
                    const deviceData = hobaData[bedItem.deviceID];
                    const isOnline = !!deviceData;
                    let inBed = false;
                    let standing = false;

                    const base64 = deviceData?.payload?.heartbreath;
                    if (base64) {
                      try {
                        const binaryString = atob(base64);
                        const bytes = Uint8Array.from(binaryString, (c) =>
                          c.charCodeAt(0)
                        );
                        const breathingValue = bytes[1]; // Solunum değeri
                        const statusByte = bytes[13] || 0;
                        const postureValue = statusByte;

                        // Eğer solunum verisi varsa yatakta
                        if (breathingValue > 0) {
                          inBed = true;
                        } else {
                          // Posture değerine göre ayakta kontrolü
                          const standStates = [7, 8];
                          if (standStates.includes(postureValue)) {
                            standing = true;
                          }
                        }
                      } catch (e) {
                        console.error(
                          "Heartbreath/solunum verisi çözülemedi:",
                          e
                        );
                      }
                    }

                    return (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        {/* Online durumu */}
                        {isOnline ? (
                          <IoIosWifi fill="green" />
                        ) : (
                          <MdSignalWifiConnectedNoInternet2 fill="red" />
                        )}

                        {/* Hasta durumu */}
                        {base64 && (
                          <>
                            {inBed && <FaBed color="orange" />}
                            {standing && <IoManSharp color="orange" />}
                          </>
                        )}
                      </div>
                    );
                  })()}

                {bedItem.brand === "Viva02P" && (
                  <p>
                    {(() => {
                      const matchingBattery = battery.filter(
                        (battery) => battery.deviceId === bedItem.deviceID
                      );
                      const lastBattery =
                        matchingBattery[matchingBattery.length - 1];
                      return lastBattery?.value ? (
                        JSON.parse(lastBattery.value).Level > 1 && <></>
                      ) : (
                        <FaPlugCircleXmark color="red" />
                      );
                    })()}
                  </p>
                )}
                {bedItem.brand === "Viva02P" && (
                  <p>
                    {(() => {
                      const matchingMessages = messages.filter(
                        (message) => message.deviceId === bedItem.deviceID
                      );

                      const highestHRMessage = matchingMessages.reduce(
                        (max, current) =>
                          current.HR > (max.HR || 0) ? current : max,
                        {}
                      );
                      return highestHRMessage?.HR ? (
                        <FaBed fill="orange" />
                      ) : (
                        <PiBedFill />
                      );
                    })()}
                  </p>
                )}
                {bedItem.brand === "Vivistar" && (
                  <div className="vivi-box">
                    <FaBatteryThreeQuarters color="green" />
                    <p>Batarya: %85</p>
                  </div>
                )}
                {/* Last Update */}
                {logs &&
                  logs.length > 0 &&
                  (() => {
                    const filteredLogs = logs.filter(
                      (log) =>
                        log.deviceId === bedItem?.deviceID &&
                        log.dataType === "event"
                    );
                    const lastFilteredLog =
                      filteredLogs[filteredLogs.length - 1];

                    const isPresenceDetected =
                      lastFilteredLog &&
                      lastFilteredLog.vayyarData?.payload &&
                      lastFilteredLog.vayyarData.payload.presenceDetected ===
                        true;

                    return (
                      isPresenceDetected && (
                        <OverlayTrigger
                          key={"top"}
                          placement={"top"}
                          overlay={
                            <Tooltip id={`tooltip-top`} className="last-update">
                              <span>Son Güncellenme Tarihi:</span>
                              <span>
                                {dateFormat(lastFilteredLog.createdAt)}
                              </span>
                            </Tooltip>
                          }
                        >
                          <Button style={{ all: "unset" }}>
                            <FcInfo />
                          </Button>
                        </OverlayTrigger>
                      )
                    );
                  })()}
              </div>
            </div>
          </div>
        ))}

        {lastAlarmsShow === true && (
          <LastFiveAlarm
            id={lastAlarmId}
            closeLastAlarmsModal={closeLastAlarmsModal}
            lat={minidata?.lat || null}
            long={minidata?.long || null}
          />
        )}

        {bed.vital === true && (
          <div className="vital-container">
            <Link to="/">
              <BsFillHeartPulseFill color="#00A3E0" size={32} />
            </Link>
          </div>
        )}
      </div>

      {show === true && (
        <AlarmModal
          alarm={alarm}
          userDetail={userDetail}
          bed={bed}
          closeModal={closeModal}
        />
      )}
    </>
  );
};

export default SameSuitCard;
